import { Component, OnInit } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { ApiserviceService } from '../../../../app/httpservice/apiservice.service';
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-configuration-data',
  templateUrl: './configuration-data.component.html',
  styleUrls: ['./configuration-data.component.scss'],
})
export class ConfigurationDataComponent implements OnInit {
  months = {}
  replaces = {}
  month = [
    {month: 'มกราคม' },
    {month: 'กุมภาพันธ์' },
    {month: 'มีนาคม' },
    {month: 'เมษายน' },
    {month: 'พฤษภาคม' },
    {month: 'มิถุนายน' },
    {month: 'กรกฎาคม' },
    {month: 'สิงหาคม' },
    {month: 'กันยายน' },
    {month: 'ตุลาคม' },
    {month: 'พฤศจิกายน' },
    {month: 'ธันวาคม' },
  ]
  reasonReplace = [
    {code: 'TIV01', value: 'ชื่อผิด'},
    {code: 'TIV02', value: 'ที่อยู่ผิด'},
    {code: 'TIV99', value: 'อื่น ๆ'}
  ] 

  cnVal: string = "";
  cnDesc: string = "";

  creditNoteReasons: any = [];
  fulltax_config: any = {};
  replace_config: any = {};
  creditnote_config: any = {};
  limit_config: any = {};

  ft_e_month: string = "";
  ft_s_month: string = "";
  ft_day_limit: string = "";
  rp_e_month: string = "";
  rp_s_month: string = "";
  rp_day_limit: string = "";
  cn_e_month: string = "";
  cn_s_month: string = "";
  cn_day_limit: string = "";

  search_limit: string = "";
  row_limit: string = "";

  constructor(
    public loadingController: LoadingController,
    public alertCtrl: AlertController,
    public apiService: ApiserviceService
  ) {
    this.months = this.month[0].month
    this.replaces = this.reasonReplace[0]
   }

  ngOnInit() {
    this.cnVal = "";
    this.cnDesc = "";
  }

  async ionViewDidEnter(){

    await this.getConfigurationData();


    console.log("this.ft_e_month=====: ",this.ft_e_month)
  }

  async addReason(){
    if(this.cnVal == ""){
      await this.manualAlert('กรุณากรอก credit note reason code.');
      return;
    }
    if(this.cnDesc == ""){
      await this.manualAlert('กรุณากรอก credit note reason description.');
      return;
    }

    this.creditNoteReasons.push({
      value: this.cnVal,
      message: this.cnDesc
    });

  }

  async manualAlert(msg: string){
    let alert = await this.alertCtrl.create({
      subHeader: msg,
    });
    await alert.present();
    setTimeout(() => {
      alert.dismiss(true);
    }, 2000);

  }

  async getConfigurationData(){
 

    await this.apiService._post(this.apiService.apiUrl + this.apiService.getConfiguration, {}).then(res=>{
      console.log('[getConfigurationData] response : ', res);

      this.creditNoteReasons = res.dropdown;
      this.fulltax_config = res.fulltax_conf;
      this.replace_config = res.replace_conf;
      this.creditnote_config = res.creditnote_conf;
      this.limit_config = res.limit_conf;

      if(res.fulltax_conf){
        this.ft_e_month = res.fulltax_conf.e_month;
        this.ft_s_month = res.fulltax_conf.s_month;
        this.ft_day_limit = res.fulltax_conf.day_limit
      }
      if(res.replace_conf){
        this.rp_e_month = res.replace_conf.e_month;
        this.rp_s_month = res.replace_conf.s_month;
        this.rp_day_limit = res.replace_conf.day_limit
      }
      if(res.creditnote_conf){
        this.cn_e_month = res.creditnote_conf.e_month;
        this.cn_s_month = res.creditnote_conf.s_month;
        this.cn_day_limit = res.creditnote_conf.day_limit
      }
      if(res.limit_conf){
        this.search_limit = res.limit_conf.search_lim;
        this.row_limit = res.limit_conf.row_lim
      }
    })

  }

  changeConfig(value: any, type: string){
    console.log(`[changeConfig] value : ${value} || type: ${type}`);
    switch (type) {
      case 'EFT':
        this.ft_e_month = value;
        break;
      case 'SFT':
        this.ft_s_month = value;
        break;
      case 'DLFT':
        this.ft_day_limit = value
        break;
      case 'ERP':
        this.rp_e_month = value;
        break;
      case 'SRP':
        this.rp_s_month = value;
        break;
      case 'DLRP':
        this.rp_day_limit = value
        break;
      case 'ECN':
        this.cn_e_month = value;
        break;
      case 'SCN':
        this.cn_s_month = value;
        break;
      case 'DLCN':
        this.cn_day_limit = value
        break;
      case 'SEARCH_LIMIT':
        this.search_limit = value
        break;
      case 'ROW_LIMIT':
        this.row_limit = value
        break;
    }
  }

  async confirmConfiguration(){

    let req_fulltax = {
      config_id: this.fulltax_config.config_id,
      e_month: this.ft_e_month,
      s_month: this.ft_s_month,
      day_limit: parseInt(this.ft_day_limit!=''?this.ft_day_limit:'0'),
    };

    let req_replace = {
      config_id: this.replace_config.config_id,
      e_month: this.rp_e_month,
      s_month: this.rp_s_month,
      day_limit: parseInt(this.rp_day_limit!=''?this.rp_day_limit:'0'),
    };

    let req_cn = {
      config_id: this.creditnote_config.config_id,
      e_month: this.cn_e_month,
      s_month: this.cn_s_month,
      day_limit: parseInt(this.cn_day_limit!=''?this.cn_day_limit:'0'),
    };

    let reqBody = {
      configuration: {
        fulltax: req_fulltax,
        replace: req_replace,
        creditnote: req_cn,
      }
    };

    console.log('[confirmConfiguration] reqBody : ', reqBody);

    await this.apiService._post(this.apiService.apiUrl + this.apiService.updateConfiguration, reqBody).then(async res=>{
      console.log('[confirmConfiguration] res : ', res);

      await this.manualAlert('บันทึกข้อมูลสำเร็จ');

      await this.getConfigurationData();
    })
      

  }

  async confirmLimit(){
    let reqBody = {
      limit: {
        config_id: this.limit_config.config_id,
        row_limit: this.row_limit,
        search_lim: this.search_limit
      }
    }

    console.log('[confirmLimit] reqBody : ', reqBody);
    await this.apiService._post(this.apiService.apiUrl + this.apiService.updateConfiguration, reqBody).then(async res=>{
      console.log('[confirmLimit] res : ', res);

      await this.manualAlert('บันทึกข้อมูลสำเร็จ');

      await this.getConfigurationData();
    })
  }

  changeCreditNoteReason(value: any, indx: number){
    console.log('[changeCreditNoteReason] value : ', value, ' index : ', indx);

    this.creditNoteReasons[indx].value_th = value;

    console.log('[changeCreditNoteReason] creditNoteReasons : ', this.creditNoteReasons);
  }

  async confirmCreditNoteReason(){
 

    let reasons = [];
    for(let i of this.creditNoteReasons){
      reasons.push({
        dropd_id: i.dropd_id,
        value_th: i.value_th
      });
    }
    let reqBody = {
      reason: reasons 
    };

    console.log('[confirmCreditNoteReason] reqBody : ', reqBody);
    await this.apiService._post(this.apiService.apiUrl + this.apiService.updateConfiguration, reqBody).then(async res=>{
      console.log('[confirmCreditNoteReason] res : ', res);
    
      await this.manualAlert('บันทึกข้อมูลสำเร็จ');

      await this.getConfigurationData();
    })
  }

}

